export default __webpack_public_path__ + "static/media/compra-en-linea-2024-family.6299f49b.jpg";